import { useContext } from "react";
import { AbilityContext } from "./AbilityContext";
export { AbilityContext };
export { default as abilityFor } from "./ability";
export { default as UsersList } from "./UsersList";
export { default as UserView } from "./UserView";
export { default as UserForm } from "./UserForm";
export const useAbility = () => useContext(AbilityContext);
